import axios from '~/axios';
import moment from 'moment';

class Utility {
    /**
     * Retrieves all dates on which sessions are scheduled for a site.
     *
     * @param {string} site - The site to get sessions for.
     */
    static async getDatesForSite(site) {
        console.info('Getting dates for ' + site);
        const data = await axios.get("api/sessions/site/" + site).then(response => {
            return this.removeDuplicateDates(response.data.data);
        }).catch(function (error) {
            console.error(error);
        });
        return data;
    }

    /**
     * Retrieves all sessions at a specific site on a specific date.
     *
     * @param {string} site - The site to get sessions for.
     * @param {number/string} date - The date to get sessions for.
     */
    static async getSessionsForSiteDate(site, date) {
        console.info('Getting sessions at ' + site + ' on ' + date);
        const data = await axios.get("api/sessions/site/" + site + "/date/" + date).then(response => {
            return response.data.data;
        }).catch(error => {
            console.error(error);
        });
        return data;
    }

    /**
     * Retrieves all dates on which sessions are scheduled at a site for a specific orientation day (1, 2, 3, or 4).
     *
     * @param {string} site - The site to get dates for.
     * @param {number/string} day - The orientation day to get dates for.
     */
    static async getDatesForSiteDay(site, day) {
        console.info('Getting dates for ' + site + ' on day ' + day);
        const data = await axios.get("api/sessions/site/" + site + "/day/" + day).then(response => {
            return this.removeDuplicateDates(response.data);
        }).catch(function (error) {
            console.error(error);
        });
        return data;
    }

    /**
     * Removes duplicate dates in an array.
     * @param {array} dates - The array of dates to convert.
     */
    static removeDuplicateDates(dates) {
        let moments = [];
        dates.map(object => {
            moments.push(moment(object.startTime).format('YYYY-MM-DD'));
        });
        let set = new Set(moments);
        return Array.from(set.values());
    }

    /**
     * Converts a number to its English name.
     * @param {number/string} number - The number to convert.
     */
    static numberName(day) {
        switch (day) {
            case 1:
            case '1':
                return 'One';
            case 2:
            case '2':
                return 'Two';
            case 3:
            case '3':
                return 'Three';
            case 4:
            case '4':
                return 'Four';
            default:
                console.error("day didn't match in dayString");
                break;
        }
    }
}

export default Utility;
